"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeErrors = exports.http = void 0;
var axios_1 = __importDefault(require("axios"));
var axios_extensions_1 = require("axios-extensions");
var query_string_1 = __importDefault(require("query-string"));
var UrlService_1 = require("./UrlService");
var globalErrorHandler_1 = __importDefault(require("./globalErrorHandler"));
exports.http = axios_1.default.create({
    headers: { 'Cache-Control': 'no-cache' },
    adapter: axios_extensions_1.cacheAdapterEnhancer(axios_1.default.defaults.adapter, {
        enabledByDefault: false,
    }),
});
exports.http.CancelToken = axios_1.default.CancelToken;
exports.http.isCancel = axios_1.default.isCancel;
exports.http.interceptors.response.use(function (response) {
    return response;
}, globalErrorHandler_1.default.handle);
var safeErrors = function (response) {
    return response && response.data && response.data.errors
        ? response.data.errors
        : [];
};
exports.safeErrors = safeErrors;
var createRequestConfig = function (bearerToken, params, accept, responseType, cache) {
    if (params === void 0) { params = {}; }
    if (accept === void 0) { accept = 'application/json'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = {
                headers: {
                    Authorization: "Bearer " + bearerToken,
                    GraphApiAuthorization: "Bearer " + sessionStorage.getItem('msGraphAccessToken'),
                    Accept: accept,
                },
            };
            if (params) {
                config.params = __assign({}, params);
                config.paramsSerializer = function (paramsToSerialize) {
                    return query_string_1.default.stringify(paramsToSerialize);
                };
            }
            if (responseType) {
                config.responseType = responseType;
            }
            if (cache) {
                config.cache = cache;
            }
            return [2 /*return*/, config];
        });
    });
};
var axiosRequestBuilder = function (apiBasePath, relativePath, bearerToken, params, accept, responseType, cache) {
    if (accept === void 0) { accept = 'application/json'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        url: UrlService_1.buildUrl(apiBasePath, relativePath)
                    };
                    return [4 /*yield*/, createRequestConfig(bearerToken, params, accept, responseType, cache)];
                case 1: return [2 /*return*/, (_a.requestConfig = _b.sent(),
                        _a)];
            }
        });
    });
};
var transformResponse = function (response) {
    var _a = response.data, data = _a === void 0 ? {} : _a;
    var _b = data.data, dataInner = _b === void 0 ? data : _b, errors = data.errors, message = data.message;
    return __assign(__assign({}, response), { data: dataInner, errors: errors, message: message });
};
var HttpClient = /** @class */ (function () {
    function HttpClient(apiBasePath, getBearerToken) {
        this.apiBasePath = apiBasePath;
        this.getBearerToken = function (path) {
            return getBearerToken && getBearerToken(path);
        };
    }
    HttpClient.prototype.get = function (relativePath, params, cancelWithoutBearerToken, setCancelToken, cache, responseType) {
        if (params === void 0) { params = {}; }
        if (cancelWithoutBearerToken === void 0) { cancelWithoutBearerToken = false; }
        if (setCancelToken === void 0) { setCancelToken = undefined; }
        if (cache === void 0) { cache = undefined; }
        if (responseType === void 0) { responseType = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var bearerToken, _a, url, requestConfig, _b, _c, cancelToken, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1:
                        bearerToken = _d.sent();
                        if (cancelWithoutBearerToken && !bearerToken)
                            return [2 /*return*/, undefined];
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 2: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params,
                            undefined,
                            responseType,
                            cache]))];
                    case 3:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        if (setCancelToken) {
                            cancelToken = exports.http.CancelToken.source();
                            setCancelToken(cancelToken);
                            requestConfig.cancelToken = cancelToken.token;
                        }
                        return [4 /*yield*/, exports.http.get(url, requestConfig)];
                    case 4:
                        response = _d.sent();
                        return [2 /*return*/, transformResponse(response)];
                }
            });
        });
    };
    HttpClient.prototype.getHtml = function (relativePath, params, bypassGlobalErrorHandler) {
        if (params === void 0) { params = {}; }
        if (bypassGlobalErrorHandler === void 0) { bypassGlobalErrorHandler = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params,
                            'text/html']))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [4 /*yield*/, exports.http.get(url, __assign(__assign({}, requestConfig), { bypassGlobalErrorHandler: bypassGlobalErrorHandler }))];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    HttpClient.prototype.getPDF = function (relativePath, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params,
                            'application/pdf',
                            'blob']))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [4 /*yield*/, exports.http.get(url, requestConfig)];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    HttpClient.prototype.postDeprecated = function (relativePath, data, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params]))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [2 /*return*/, new Promise(function (res) {
                                return axios_1.default
                                    .post(url, data, requestConfig)
                                    .then(function (response) { return res(__assign(__assign({}, response), { data: response.data.data })); })
                                    .catch(function (_a) {
                                    var response = _a.response;
                                    return res(__assign(__assign({}, response), { data: undefined, errors: exports.safeErrors(response) }));
                                });
                            })];
                }
            });
        });
    };
    HttpClient.prototype.post = function (relativePath, data, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params]))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [4 /*yield*/, exports.http.post(url, data, requestConfig)];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, transformResponse(response)];
                }
            });
        });
    };
    HttpClient.prototype.fileUpload = function (httpOperationName, relativePath, data, file, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, formData, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params]))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        formData = new FormData();
                        formData.append('file', file);
                        Object.keys(data).forEach(function (key) { return formData.append(key, data[key]); });
                        requestConfig.headers['content-type'] = 'multipart/form-data';
                        return [4 /*yield*/, exports.http[httpOperationName](url, formData, requestConfig)];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, transformResponse(response)];
                }
            });
        });
    };
    HttpClient.prototype.postFile = function (relativePath, data, file, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileUpload('post', relativePath, data, file, params)];
            });
        });
    };
    HttpClient.prototype.putFile = function (relativePath, data, file, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fileUpload('put', relativePath, data, file, params)];
            });
        });
    };
    HttpClient.prototype.put = function (relativePath, data, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params]))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [4 /*yield*/, exports.http.put(url, data, requestConfig)];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, transformResponse(response)];
                }
            });
        });
    };
    HttpClient.prototype.patch = function (relativePath, data, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params]))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [4 /*yield*/, exports.http.patch(url, data, requestConfig)];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, transformResponse(response)];
                }
            });
        });
    };
    HttpClient.prototype.delete = function (relativePath, params) {
        if (params === void 0) { params = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, requestConfig, _b, _c, response;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = axiosRequestBuilder;
                        _c = [this.apiBasePath,
                            relativePath];
                        return [4 /*yield*/, this.getBearerToken(relativePath)];
                    case 1: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d.sent(), params]))];
                    case 2:
                        _a = _d.sent(), url = _a.url, requestConfig = _a.requestConfig;
                        return [4 /*yield*/, exports.http.delete(url, requestConfig)];
                    case 3:
                        response = _d.sent();
                        return [2 /*return*/, transformResponse(response)];
                }
            });
        });
    };
    return HttpClient;
}());
exports.default = HttpClient;
